import useSWRImmutable from "swr/immutable";

import { getFeatureFlag } from "../../constants/featureFlags";

import type { FeatureFlag } from "../../constants/featureFlags";

const getLLHLSFeatureFlag = async (): Promise<FeatureFlag | undefined> => {
  return await getFeatureFlag("llhls");
};

export const useEnableLLHLS = (
  eventId: string | undefined
): boolean | undefined => {
  const { data: llhlsFeatureFlag } = useSWRImmutable<FeatureFlag>(
    "getLLHLSFeatureFlag",
    async () => {
      let flag: FeatureFlag | undefined;
      try {
        flag = await getLLHLSFeatureFlag();
        console.debug({ flag });
      } catch (error) {
        console.debug("Failed to fetch LLHLS feature flag:", error);
        return {
          globalEnabled: false,
          events: {},
        };
      }
      if (flag === undefined) {
        console.debug("Feature flag is undefined, returning default");
        return {
          globalEnabled: false,
          events: {},
        };
      }
      return flag;
    }
  );

  try {
    // From URL parameters
    const params = new URLSearchParams(window.location.search);
    if (params.get("useLLHLS") === "1") {
      return true;
    }

    if (params.get("disableLLHLS") === "1") {
      return false;
    }

    // loading
    if (llhlsFeatureFlag === undefined) {
      return undefined;
    }

    // From Firestore
    if (llhlsFeatureFlag.globalEnabled) {
      return true;
    }
    if (eventId && llhlsFeatureFlag.events[eventId]) {
      return true;
    }

    // Default to false
    return false;
  } catch (error) {
    return false;
  }
};
